var map = {
	"./NRP.jpg": "OKCu",
	"./bauges-park.jpg": "BCYe",
	"./brel.jpg": "jO9f",
	"./camonica-valley.jpg": "MOls",
	"./crepa.jpg": "IHfH",
	"./dislivelli-association.jpg": "SXGt",
	"./europe-logo.jpg": "7qbX",
	"./european-year.jpg": "6DkJ",
	"./european-year.png": "n//d",
	"./kedge-business-school.jpg": "6LGH",
	"./lombardy-region.jpg": "mw6x",
	"./munich-university-of-applied-sciences.jpg": "6A06",
	"./polo-poschiavo.jpg": "D3Vz",
	"./ragor.jpg": "djDa",
	"./rda.jpg": "k+oK",
	"./tsm.jpg": "YcFV",
	"./uibk.jpg": "7xEH",
	"./zrc-sazu.jpg": "y2RP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IJJN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners ^\.\/.*$
// module id = IJJN
// module chunks = 1